import gql from 'graphql-tag'

export default {
  ticketsForParent() {
    return {
      query: gql`
        query Query($status: String, $serviceId: Int!) {
          ticketsForParent(
            status: $status
            parent_id: $serviceId
            parent_type: "Service_Location"
            orderBy: [{ column: STATUS, order: ASC }]
          ) {
            id
            severity
            ticket_type
            status
            sla_time_open_mins
            updated_at
            is_cf_ticket
            noc_time
            time_open
            ticket_parent {
              ... on ServiceLocation {
                id
                name(short: true)
              }
              ... on Site {
                id
                name
              }
              ... on Service {
                id
                name
              }
            }
            team {
              id
              name
            }
            assigned_user {
              id
              full_name
            }
          }
        }
      `,
      skip() {
        return !this.serviceLocationId
      },
      variables() {
        return {
          serviceId: this.serviceLocationId,
          status: this.status
        }
      }
    }
  }
}
